<template>
    <div class="content">
        <div class="hw-content">
            <div style="margin-bottom: 20px">
                <span>报价单信息：</span>
                <el-button type="primary" v-for="(item, index) in SPCApply_ButtonAll"
                    v-show="item.value == '可用' || item.value == '不可用'" :disabled="item.value == '不可用'" :key="index"
                    @click="setControls(item.name)">{{ item.name }}</el-button>
                <span style="margin-left: 50px">打印：</span>
                <el-button
                    v-if="details.SpcApplyInfo.SPCApply_Status < 2 && details.SpcApplyInfo.SPCApply_SourceType != 1"
                    type="primary" @click="printSendOrder()">打印报价单</el-button>
                <el-button
                    v-if="details.SpcApplyInfo.SPCApply_Status < 2 && details.SpcApplyInfo.SPCApply_SourceType != 1"
                    type="primary" @click="chooseSendOrder()">发送报价单</el-button>
                <el-button
                    v-if="details.SpcApplyInfo.SPCApply_Status < 2 && details.SpcApplyInfo.SPCApply_SourceType != 1"
                    type="primary" @click="exportSendOrder()">导出报价单</el-button>
                <el-button
                    v-if="details.SpcApplyInfo.SPCApply_Status < 2 && details.SpcApplyInfo.SPCApply_SourceType != 1"
                    type="primary" @click="chooseSendExccel()">发送excel</el-button>
            </div>
            <el-collapse v-model="activeNames">
                <el-collapse-item title="基本信息" name="2">
                    <div>
                        <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                            <el-descriptions-item label="报价单编号	">
                                <div class="rows">{{ details.SpcApplyInfo.SPCApply_SN }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="下单时间">
                                <div class="rows">{{ details.SpcApplyInfo.SPCApply_Addtime | formatDates }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="版本号">{{ details.SpcApplyInfo.SPCApply_Version
                                }}</el-descriptions-item>
                            <el-descriptions-item label="行业分类">
                                {{ details.SpcApplyInfo.SPCApply_ProjectType_Name }}
                            </el-descriptions-item>
                            <el-descriptions-item label="审核状态">
                                <span :class="judgeColor(details.SpcApplyInfo.SPCApplyAuditStatus)">{{
                                    details.SpcApplyInfo.SPCApplyAuditStatus }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="BPM审核状态">
                                <span :class="judgeColor(details.SpcApplyInfo.SPCApplyBPMStatus)">{{
                                    details.SpcApplyInfo.SPCApplyBPMStatus }}</span>
                                <span class="ml20"
                                    v-if="details.SpcApplyInfo.SPCApply_BPMStatus > 0 && details.SpcApplyInfo.SPCApply_BPMBizObjectID != ''">
                                    <el-button type="primary" @click="searchBpm()">查询审批情况</el-button>
                                </span>
                            </el-descriptions-item>
                            <el-descriptions-item label="大区">{{ details.SpcApplyInfo.SPCApply_BigAreaName
                                }}</el-descriptions-item>
                            <el-descriptions-item label="小区">{{ details.SpcApplyInfo.SPCApply_SmallAreaName
                                }}</el-descriptions-item>
                            <el-descriptions-item label="办事处">{{ details.SpcApplyInfo.SPCApply_OfficeCode
                                }}</el-descriptions-item>
                            <el-descriptions-item label="业务员	">{{ details.SpcApplyInfo.Orders_OfficeMan
                                }}</el-descriptions-item>
                            <el-descriptions-item label="工程名称">{{ details.SpcApplyInfo.SPCApply_ProjectName
                                }}</el-descriptions-item>
                            <el-descriptions-item label="工程地址">{{ details.SpcApplyInfo.Address }}</el-descriptions-item>
                            <!-- <el-descriptions-item label="工基建项目说明" :span="2">{{ details.SpcApplyInfo.SPCApply_ProjectNote
                                }}</el-descriptions-item> -->
                            <el-descriptions-item label="预计发货时间">{{ details.SpcApplyInfo.SPCApply_PlanDeliveryDays |
                                formatDate }}</el-descriptions-item>
                            <el-descriptions-item label="项目总金额">
                                <span class="is-status-text">￥{{ details.SpcApplyInfo.SPCApply_TotalPrice }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="返货金额" v-if="details.SpcApplyInfo.SPCApply_ReturnGoodsPrice">
                                <span class="is-status-text">￥{{ details.SpcApplyInfo.SPCApply_ReturnGoodsPrice
                                    }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="返货比例" v-if="details.GoodsReturnRate">
                                <span class="is-status-text">{{ details.GoodsReturnRate }}</span>
                                %
                            </el-descriptions-item>
                            <el-descriptions-item label="来源类型">
                                {{ details.SpcApplyInfo.SPCApplySourceTypeName }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="付款方式" name="3">
                    {{ details.SpcApplyInfo.SPCApply_PayTypeName }}
                </el-collapse-item>

                <el-collapse-item title="客户信息" name="4">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="客户编码	">
                            <div class="rows">{{ details.CustomerAndMember.Orders_CustomerCode }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="客户名称">
                            <div class="rows">{{ details.CustomerAndMember.Orders_CustomerName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="客户手机">
                            <div class="rows">{{ details.CustomerAndMember.Orders_CustomerMobile }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="年检到期日期">
                            {{ details.CustomerAndMember.Customer_CertExpireDate | formatDate }}
                        </el-descriptions-item>
                        <el-descriptions-item label="会员账号">
                            {{ details.CustomerAndMember.Member_NickName }}
                        </el-descriptions-item>
                        <el-descriptions-item label="姓名">
                            {{ details.CustomerAndMember.Member_Name }}
                        </el-descriptions-item>
                        <el-descriptions-item label="固定电话">
                            {{ details.CustomerAndMember.Member_Phone_Number }}
                        </el-descriptions-item>
                        <el-descriptions-item label="手机">
                            {{ details.CustomerAndMember.Member_Mobile }}
                        </el-descriptions-item>
                        <el-descriptions-item label="Email">
                            {{ details.CustomerAndMember.Member_Email }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="特价信息" name="9" v-if="details.Special != null">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="业务区域	">
                            <div class="rows">{{ details.Special.Special_Region }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="合作规模">
                            <div class="rows">￥{{ details.Special.Special_FutureScale }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="A类预期平均折扣">
                            <div class="rows">{{ details.Special.Special_FutureAvgDiscount }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="B类预期平均折扣">
                            {{ details.Special.Special_FutureAvgDiscountB }}
                        </el-descriptions-item>
                        <el-descriptions-item label="是否新客户">
                            {{ details.Special.Special_IsNewCustomer == 1 ? '是' : '否' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="客户简介">
                            {{ details.Special.Special_CustomerIntro }}
                        </el-descriptions-item>
                        <el-descriptions-item label="多期开发规划">
                            {{ details.Special.Special_IsMoreTermsPlan == 1 ? '是' : '否' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="折扣仅适用于此项目">
                            {{ details.Special.Special_IsNoLow == 1 ? '是' : '否' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="业务背景">
                            {{ details.Special.Special_BusinessIntro }}
                            <text style="margin-right: 5rpx"
                                v-if="details.Special.Special_BusinessIntro && details.Special.Special_BusinessNote">;</text>
                            {{ details.Special.Special_BusinessNote }}
                        </el-descriptions-item>
                        <el-descriptions-item label="价格有效期">{{ details.Special.Special_Start | formatDate }}至{{
                            details.Special.Special_End | formatDate }}</el-descriptions-item>
                        <el-descriptions-item label="特价类型">
                            {{ details.Special.Special_Type }}
                        </el-descriptions-item>
                        <el-descriptions-item label="是否根据图纸预估销售额">
                            {{ details.Special.Special_IsPaper == 1 ? '是' : '否' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="项目是否为独家专供">
                            {{ details.Special.Special_ExpertRate >= 0 ? details.Special.Special_ExpertRate + '%' :
                            '尚不确定' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="库存订单未来发货金额">
                            {{ details.Special.Special_LaterFreightAmount }}
                        </el-descriptions-item>
                        <el-descriptions-item label="是否原折扣率发货">
                            {{ details.Special.Special_IsSourceDiscountFreight == 1 ? '是' : '否' }}
                        </el-descriptions-item>
                        <el-descriptions-item label=""></el-descriptions-item>
                        <el-descriptions-item label="竞争对手信息">
                            <el-table :data="details.Competitor" style="width: 100%" border
                                :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                                <el-table-column prop="Competitor_Name" label="名称" align="center"></el-table-column>
                                <el-table-column prop="Competitor_CateADiscount" label="A类折扣"
                                    align="center"></el-table-column>
                                <el-table-column prop="Competitor_CateBDiscount" label="B类折扣"
                                    align="center"></el-table-column>
                            </el-table>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="关联商机信息" name="5" v-if="details.SPCApply_SMDSPipelineInfo">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="商机编码	">
                            <div class="rows">{{ details.SPCApply_SMDSPipelineInfo.opportunityName }}({{
                                details.SPCApply_SMDSPipelineInfo.ID }})</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="项目名称">
                            <div class="rows">{{ details.SPCApply_SMDSPipelineInfo.projectName }}({{
                                details.SPCApply_SMDSPipelineInfo.entityType }})</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="项目阶段">
                            {{ details.SPCApply_SMDSPipelineInfo.stageName }}
                        </el-descriptions-item>
                        <el-descriptions-item label="客户信息">
                            （{{ details.SPCApply_SMDSPipelineInfo.erpid }}）{{
                                details.SPCApply_SMDSPipelineInfo.accountName }}

                        </el-descriptions-item>
                        <el-descriptions-item label="联系人">
                            {{ details.SPCApply_SMDSPipelineInfo.contact }}
                        </el-descriptions-item>
                        <el-descriptions-item label="所有人">
                            {{ details.SPCApply_SMDSPipelineInfo.userName }}
                        </el-descriptions-item>
                        <el-descriptions-item label="预计项目金额">
                            {{ details.SPCApply_SMDSPipelineInfo.money }}
                        </el-descriptions-item>
                        <el-descriptions-item label="项目类型">
                            {{ details.SPCApply_SMDSPipelineInfo.industry1 }}
                        </el-descriptions-item>
                        <el-descriptions-item label="需货时间">
                            {{ details.SPCApply_SMDSPipelineInfo.demandDate }}
                        </el-descriptions-item>
                        <el-descriptions-item label="创建日期">
                            {{ details.SPCApply_SMDSPipelineInfo.createdAt }}
                        </el-descriptions-item>
                        <el-descriptions-item label="项目地址">
                            {{ details.SPCApply_SMDSPipelineInfo.province }} {{ details.SPCApply_SMDSPipelineInfo.city
                            }} {{ details.SPCApply_SMDSPipelineInfo.area }} {{ details.SPCApply_SMDSPipelineInfo.address
                            }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
                <el-collapse-item title="关联合同" name="6">
                    <el-table :data="applyRelateResult" border style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="Orders_SN" label="合同号" align="center">
                            <template v-slot="scope">
                                <span class="links" @click="goSPCOrderdetail(scope.row.Orders_ID)">{{
                                    scope.row.Orders_SN }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_Total_AllPrice" label="合同总额" align="center">
                            <template v-slot="scope">
                                <span>￥{{ getFloat(scope.row.Orders_Total_AllPrice, 2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_Return_AllPrice" label="返货金额" align="center">
                            <template v-slot="scope">
                                <span>￥{{ getFloat(scope.row.Orders_Return_AllPrice, 2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_Status" label="合同状态" align="center">
                            <template v-slot="scope">
                                <span :class="judgeColor(scope.row.Orders_Status)">{{ scope.row.Orders_Status }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_BPMAuditStatus" label="BPM审核状态" align="center">
                            <template v-slot="scope">
                                <span :class="judgeColor(scope.row.Orders_BPMAuditStatus)">{{
                                    scope.row.Orders_BPMAuditStatus }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_Addtime" label="下单时间" align="center">
                            <template v-slot="scope">
                                <span>{{ scope.row.Orders_Addtime | formatDates }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>
                <el-collapse-item title="折扣分组" name="7">
                    <el-table :data="DiscountList" border style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="Name" label="折扣分组" align="center"></el-table-column>
                        <el-table-column prop="OrderAmount" label="面价金额" align="center"
                            v-if="DiscountList[0] && DiscountList[0].OrderAmount != -1">
                            <template v-slot="scope">
                                <div v-if="scope.row.OrderAmount != -1">
                                    ￥
                                    {{ getFloat(scope.row.OrderAmount, 2) }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ProductAmount" label="商品金额" align="center"
                            v-if="DiscountList[0] && DiscountList[0].OrderAmount != -1">
                            <template v-slot="scope">
                                <div v-if="scope.row.OrderAmount != -1">
                                    ￥
                                    {{ getFloat(scope.row.ProductAmount, 2) }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Discount" label="折扣率" align="center"></el-table-column>
                    </el-table>
                </el-collapse-item>
                <el-collapse-item title="商品清单" name="8">
                    <div :key="ix" v-for="(item, ix) in Commoditylist">
                        <el-table :data="item.Goods" style="width: 100%" border
                            :header-cell-style="{ backgroundColor: '#EBEEF5' }" :show-header="ix == 0"
                            :span-method="spanMethod">
                            <el-table-column prop="Goods_Product_MainBoxNumber" label="箱号" width="80">
                                <template v-slot="scope">
                                    <div v-if="scope.row.last" style="text-align: left">
                                        <div v-if="scope.row.maxlast" style="font-size:14px;">
                                            项目总金额：
                                            <span style="color: red">￥{{ details.SpcApplyInfo.SPCApply_TotalPrice |
                                                formatePrice}}</span>
                                        </div>
                                        <div v-else class="total">
                                            <div v-if="item.Orders_Price > 0">
                                                商品金额合计:
                                                <span>￥{{ item.Porduct_Pirce || 0 | formatePrice }}</span>
                                                申请金额:
                                                <span>￥{{ item.Orders_Price || 0 | formatePrice }}</span>
                                                折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) *
                                                100).toFixed(2)) }}%
                                                <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) *
                                                    10).toFixed(3) | formatePrice3}}折</span>
                                            </div>
                                            <div v-else>
                                                折扣率:{{ Number((item.MinDiscount * 100).toFixed(2)) }}%
                                                <span class="">{{ Number(item.MinDiscount * 10).toFixed(3) |
                                                    formatePrice3}}折</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="scope.row.start" style="text-align: left; font-weight: 700">{{
                                        scope.row.Goods_Product_MainBoxNumber }}：</div>
                                    <div v-else style="text-align: center">{{ scope.row.Goods_Product_MainBoxNumber }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Product_Name" label="商品" align="center"
                                width="300"></el-table-column>
                            <el-table-column prop="Goods_Product_Spec" label="规格" align="center"></el-table-column>
                            <el-table-column prop="Goods_Product_Maker" label="生产企业" align="center"></el-table-column>
                            <el-table-column prop="Goods_Product_Price" label="单价" align="center">
                                <template v-slot="scope">
                                    <div style="color: red">￥ {{ scope.row.Goods_Product_Price }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Amount" label="数量" align="center"></el-table-column>
                            <el-table-column prop="TransferredOrder_Amount" label="已转订单数量" align="center"
                                width="150"></el-table-column>
                            <el-table-column prop="Remaining_Amount" label="剩余可用数量" align="center"
                                width="150"></el-table-column>
                            <el-table-column prop="Goods_IsSaveOrder" label="保存转订单" align="center">
                                <template v-slot="scope">
                                    <div>
                                        {{ scope.row.Goods_IsSaveOrder ? '是' : '否' }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_TotalPrice" label="合计" align="center">
                                <template v-slot="scope">
                                    <div style="color: red">￥ {{ scope.row.Goods_TotalPrice | formatePrice }}</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="审核说明" name="9">
                    <el-table :data="AuditNotes" border style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Note_Note" label="备注"></el-table-column>
                    </el-table>
                </el-collapse-item>
                <el-collapse-item title="报价单日志" name="10">
                    <el-table :data="SPCApply_log" border style="width: 100%"
                        :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Log_Addtime" label="时间" align="center" width="150">
                            <template v-slot="scope">
                                {{ scope.row.Log_Addtime | formatDates }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Log_Operator" label="操作人" align="center" width="150"></el-table-column>
                        <el-table-column prop="Log_Remark" label="备注" align="left"></el-table-column>
                    </el-table>
                </el-collapse-item>
            </el-collapse>
        </div>
        <BPMExamine :isSwitch="isSwitch" :id="details.SpcApplyInfo.SPCApply_BPMBizObjectID"
            @setSwitchClose="setSwitchClose" v-if="isSwitch"></BPMExamine>
        <PrintHtml :isSwitch="printSwitch" :checked="false" :html="printHtml" @setSwitchClose="printSwitchClose"
            :numsituation="3" :sealTrue="sealTrue" v-if="printSwitch"></PrintHtml>
        <el-dialog title="报价单关闭" :visible.sync="dialogVisible" width="500px" :before-close="dialogBeforeClose">
            <div>
                <el-form ref="form" label-width="80px">
                    <el-form-item label="关闭原因">
                        <el-input type="textarea" v-model="orders_cancel_note"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" style="text-align: center">
                <el-button @click="dialogBeforeClose()">取 消</el-button>
                <el-button type="primary" @click="SPCApply_Close()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import BPMExamine from '@/components/BPMExamine';
import PrintHtml from '@/components/PrintHtml';
export default {
    name: 'quotationDetails',
    components: {
        BPMExamine,
        PrintHtml
    },
    data() {
        return {
            activeNames: ['2', '3', '4', '9', '5', '6', '7', '8', '10'],
            dialogVisible: false,
            orders_cancel_note: '',
            customerType: 0,
            details: {
                Special: null,
                CustomerAndMember: {},
                SpcApplyInfo: {},
                SPCApply_SMDSPipelineInfo: {},
                SPCApply_Button: {},
                Competitor: null,
                Pipeline_SN: ''
            },
            SPCApply_log: [],
            DiscountList: [],
            AuditNotes: [],
            Commoditylist: [],
            applyRelateResult: [],
            isSwitch: false, // bmp审核弹窗
            printSwitch: false, // 打印弹窗
            printHtml: '', // 打印内容
            sealTrue: false, //  sealTrue
            numsituation: 0, // 印章显示情况
            SPCApply_ButtonAll: [] // 按钮集合
        };
    },
    mounted() {
        const id = this.$route.query.id;
        console.log(id, 'idid');
        if (id) {
            this.id = id;
            this.getSPCApplyDetailByApplyID(this.id);
        }
    },
    methods: {
        /*
        获取详情数据
        */
        async getSPCApplyDetailByApplyID(Apply_ID) {
            try {
                let loadingInstance = this.$loading({ target: '.hw-content' });
                const res = await this.$newsApi.getSPCApplyDetailByApplyID({ Apply_ID });
                if (res.data.data) {
                    this.details = res.data.data;
                    if (this.details.SpcApplyInfo.SPCApply_SMDSPipelineInfo) {
                        this.details.SPCApply_SMDSPipelineInfo = JSON.parse(this.details.SpcApplyInfo.SPCApply_SMDSPipelineInfo);
                    }
                    if (this.details.SPCApply_Button) {
                        var returnbtn = '可用';
                        if (!this.details.SPCApply_Button['创建返货合同提示'] == '') {
                            returnbtn = this.details.SPCApply_Button['创建返货合同'];

                            this.details.SPCApply_Button['创建返货合同'] = '可用';
                        }
                        this.SPCApply_ButtonAll = Object.entries(this.details.SPCApply_Button).map(([key, value]) => ({ name: key, value }));
                        if (!this.details.SPCApply_Button['创建返货合同提示'] == '') {
                            this.details.SPCApply_Button['创建返货合同'] = returnbtn;
                        }
                    }

                    const req = await this.$newsApi.getSPCApplyRelateSPCOrdersList({ spcapply_sn: this.details.SpcApplyInfo.SPCApply_SN });
                    this.applyRelateResult = req.data.data;
                    const res1 = await this.$newsApi.getSPCApplyLogsByApplyID({ ApplyID: Apply_ID });
                    this.SPCApply_log = res1.data.data;
                    const res2 = await this.$newsApi.getSPCApplyGoodsByApplyID({ ApplySN: this.details.SpcApplyInfo.SPCApply_SN, ApplyID: Apply_ID });
                    let Commoditylist = res2.data.data;
                    Commoditylist.forEach((el, ix) => {
                        el.Goods.unshift({ Goods_Product_MainBoxNumber: el.DiscountCateName, spanMethod: true, start: true });
                        el.Goods.push({ Goods_Product_MainBoxNumber: '', last: true, spanMethod: true, Porduct_Pirce: el.Porduct_Pirce, Orders_Price: el.Orders_Price, MinDiscount: el.MinDiscount });
                        if (ix == Commoditylist.length - 1) {
                            el.Goods.push({ Goods_Product_MainBoxNumber: '', spanMethod: true, last: true, maxlast: true });
                        }
                    });
                    this.Commoditylist = Commoditylist;
                    const res3 = await this.$newsApi.getSPCApplyDiscountCate({ ApplyID: Apply_ID });
                    this.DiscountList = res3.data.data;
                    const res4 = await this.$newsApi.getSPCApplyAuditNotesByOrdersID({ Apply_ID });
                    this.AuditNotes = res4.data.data;
                }
                this.$closeLoading(loadingInstance); // 关闭 loading
            } catch (error) {
                this.$closeLoading(loadingInstance); // 关闭 loading
                console.log(error);
            }
        },
        spanMethod({ rowIndex, columnIndex, row, column }) {
            // 合并第一行的所有单元格
            if (row.spanMethod) {
                return [1, 10]; // 1表示合并的行数，3表示合并的列数
            }
            return [1, 1]; // 默认每个单元格都占一行一列
        },
        /*
        下载附件
        */
        downFile(par) {
            this.$newsApi.common.getUrlPath().then((res) => {
                if (res.data.Resultcode == 0) {
                    let path = res.data.data;
                    let paths = path + par;
                    window.open(paths);
                }
            });
        },
        //提交报价单
        getSPCApply_Submit() {
            this.$newsApi.order.getSPCApply_Submit({ SPCApply_ID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    setTimeout(() => {
                        this.getSPCApplyDetailByApplyID(this.id);
                    }, 2000);
                }
            });
        },
        // 报价单转合同检查
        async SPCApplyToSPCOrdersCheckMethods(e) {
            const res = await this.$newsApi.order.getSPCApplyToSPCOrdersCheck({
                ApplyID: e,
                Type: 0 //第一次为0 第二次为1
            });

            return res;
        },
        //     // 报价单转合同检查
        // async	SPCApplyToSPCOrdersCheckMethodsTwo(e){

        // 			var result = await this.$u.post('SPCApplyToSPCOrdersCheck',{
        // 				ApplyID:e,
        // 				Type:1//第一次为0 第二次为1
        // 			})
        // 			return result
        // 		},
        // 检查客户
        async chooseCustomerInfor(e) {
            const result = await this.$newsApi.order.getCheckCustomerAndCustomerSub({
                Orders_Type: 0, //订单类型
                Customer_Type: this.customerType, //客户类型
                Customer_ID: e.SPCApply_CustomerID, //客户ID
                Customer_Name: e.SPCApply_CustomerName, //客户名称
                Customer_Sub_ID: e.SPCApply_CustomerSubID || 0, //二级客户ID
                CustomerSub_Name: e.SPCApply_CustomerSubName || '', //二级客户名称
                Person_Name: e.SPCApply_CustomerName || '', //个人姓名
                Person_Mobile: e.SPCApply_CustomerMobile || '', //个人电话
                OrdersID: 0
            });
            return result.data.data;
        },
        // 一键转订单

        async SPCApplyToSPCOrdersCheck() {
            this.$confirm('将进入一键转订单流程，是否跳过客户及付款方式确认环节，直接进入转订单购物车页面?', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            })
                .then(async () => {
                    let { data: result } = await this.$newsApi.order.getSPCApplyToSPCOrdersCheck({
                        applyid: this.id,
                        Type: 0
                    });
                    if (result.Resultcode == 0) {
                        this.$store.commit('SET_ApplyStatus', 1);
                        this.$router.push({ path: '/customOrder', query: { applyId: this.id } });
                    } else {
                        this.$alert(result.Resultinfo, '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        }).then(() => {
                            return;
                        });
                    }
                    // this.$store.commit('SET_ApplyStatus', 1);
                    //     this.$router.push({ path: '/customOrder', query: { applyId: this.id } });
                })
                .catch(async () => {
                    let { data: result } = await this.$newsApi.order.getSPCApplyToSPCOrdersCheck({
                        applyid: this.id,
                        Type: 0
                    });
                    if (result.Resultcode == 0) {
                        this.$store.commit('SET_ApplyStatus', 0);
                        this.$router.push({ path: '/customOrder', query: { applyId: this.id } });
                    } else {
                        this.$alert(result.Resultinfo, '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        }).then(() => {
                            return;
                        });
                    }
                });
        },
        // 返货合同
        async SPCApplyReturnGoodsSPCOrdersCheck() {
            if (this.details.SPCApply_Button['创建返货合同'] == '可用') {
                this.$confirm(this.details.SPCApply_Button['创建返货合同提示'], '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$router.push({ path: '/customOrder', query: { returnGoodsId: this.id } });
                    })
                    .catch(() => { });
            } else {
                if (!this.details.SPCApply_Button['创建返货合同提示'] == '') {
                    this.$message.warning(this.details.SPCApply_Button['创建返货合同提示']);
                    return;
                }
            }
        },
        // 取消订单方法
        SPCApply_Close() {
            const json = JSON.stringify({ orders_cancel_note: this.orders_cancel_note, SPCApply_ID: this.id });
            this.$newsApi.order
                .getSPCApply_Close({
                    json: json
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.$message({
                            message: '取消成功',
                            type: 'success'
                        });
                        setTimeout(() => {
                            this.dialogVisible = false;
                            this.getSPCApplyDetailByApplyID(this.id);
                        }, 2000);
                    }
                });
        },
        dialogBeforeClose() {
            this.dialogVisible = false;
        },
        /*
        关闭详情
        */
        handleClose() {
            this.$emit('handleClose');
        },

        setControls(e) {
            if (e == '关闭报价单') {
                this.orders_cancel_note = '';
                this.dialogVisible = true;
            }
            if (e == '修改报价单') {
                if (this.details.SpcApplyInfo.SPCApply_BillType == 0) {
                    this.$router.push({ path: '/quotationManagement/temporarilyPricesheetadd', query: { changeSPCApplyDataID: this.id } });
                } else {
                    this.$router.push({ path: '/quotationManagement/formalPricesheetadd', query: { changeSPCApplyDataID: this.id } });
                }
            }
            if (e == '提交报价单') {
                if (this.details.SPCApply_Button['提交报价单提示']) {
                    this.$alert(this.details.SPCApply_Button['提交报价单提示'], '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    }).then(() => {
                        return false;
                    });
                } else {
                    this.$confirm('是否审核通过后直接转订单?', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    })
                    .then(() => {
                        //    清空复制合同id
                        //  this.$store.commit('submitCopySPCOrderId',0)
                        this.SPCApplyToSPCOrdersCheck();
                    })
                    .catch(() => {
                        this.getSPCApply_Submit();
                    });
                }
            }
            if (e == '一键转合同') {
                this.SPCApplyToSPCOrdersCheck();
            }
            if (e == '一键转正式') {
                this.$router.push({ path: '/quotationManagement/formalPricesheetadd', query: { applyId: this.id } });
            }
            if (e == '创建返货合同') {
                this.SPCApplyReturnGoodsSPCOrdersCheck();
            }
        },
        //发送报价单
        chooseSendOrder() {
            this.$newsApi.order.getSPCApply_SendMail({ SPCApply_ID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        type: 'success',
                        message: '发送报价单成功'
                    });
                    this.getSPCApplyDetailByApplyID(this.id);
                }
            });
        },
        //发送Excel
        chooseSendExccel() {
            this.$newsApi.order.getSPCApplyGood_SendMail({ SPCApply_ID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        type: 'success',
                        message: '发送Excel成功'
                    });
                    this.getSPCApplyDetailByApplyID(this.id);
                }
            });
        },
        // 打印报价单
        printSendOrder() {
            // window.print();
            this.$newsApi.order.SPCShopping_Goods_List_HTML({ Apply_ID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.sealTrue = this.details.SpcApplyInfo.SPCApply_BPMStatus == 2 ? true : false; // 是否打印印章
                    this.numsituation = 3; // 设置印章显示情况
                    this.printHtml = res.data.data;
                    this.printSwitch = true;
                }
            });
        },
        // 导出报价单
        exportSendOrder() {
            this.$newsApi.order.SPCApply_Export({ ApplyID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    // this.downFile(res.data.data);
                    window.open(this.$fileUrl + res.data.data, '_blank');
                }
            });
        },
        printSwitchClose() {
            this.printSwitch = false;
        },
        // 查看BPM审核
        searchBpm() {
            this.isSwitch = true;
        },
        setSwitchClose() {
            this.isSwitch = false;
        },
        goSPCOrderdetail(OrdersID) {
            this.$router.push({ path: '/orderManagement/contractmanagementDetails', query: { id: OrdersID } });
        }
    }
};
</script>

<style lang="scss" scoped>
.hw-content {
    padding: 0 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}

.content {
    background: #fff;
    padding: 20px 0;
}

.total {
    font-size: 14px;
    margin-top: 10px;

    span {
        color: red;
        padding-right: 20px;
    }
}

.links {
    color: #409eff;
    cursor: pointer;
}

/deep/.el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

/deep/.el-table--border .el-table__cell {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

/deep/.el-table {
    border: 1px solid #ccc;
}
</style>
